/** Prefijos compartidos por los formularios y el editor de teléfono. */
export const COMMON_COUNTRY_CODES = [
  { code: '+591', label: 'Bolivia (+591)', shortName: 'Bol' },
  { code: '+54', label: 'Argentina (+54)', shortName: 'Arg' },
  { code: '+55', label: 'Brasil (+55)', shortName: 'Bra' },
  { code: '+56', label: 'Chile (+56)', shortName: 'Chi' },
  { code: '+57', label: 'Colombia (+57)', shortName: 'Col' },
  { code: '+593', label: 'Ecuador (+593)', shortName: 'Ecu' },
  { code: '+51', label: 'Perú (+51)', shortName: 'Per' },
  { code: '+598', label: 'Uruguay (+598)', shortName: 'Uru' },
  { code: '+58', label: 'Venezuela (+58)', shortName: 'Ven' },
  { code: '+52', label: 'México (+52)', shortName: 'Méx' },
  { code: '+34', label: 'España (+34)', shortName: 'Esp' },
  { code: '+1', label: 'USA/Canadá (+1)', shortName: 'US/CA' },
]
